import React from 'react';
import { RouteComponentProps } from 'react-router';
import { useIonRouter } from '@ionic/react';
import { func, images, types } from 'utils';
import { Touchable } from './';

interface ContainerProps {
    row: types.Order;
    style?: any;
}
interface Props extends RouteComponentProps, types.StateProps, ContainerProps { };
const OrderCard: React.FC<Props> = (props) => {
    const router = useIonRouter();

    const { row, _data: { orderStatus, location } } = props;

    // const [row, setRow] = React.useState(props.row);

    const openOrder = () => {
        props.dispatch(props.changeData('order', row));
        setTimeout(() => {
            router.push(`/orders/${row.id}`);
        }, 300);
    }

    return (
        <React.Fragment>
            <Touchable onClick={() => openOrder()} className="mb-3">
                <div id="OrderCard" className="p-3 bg-white shadow">
                    <div className="pt-2r">
                        <div className="text-center fw-600 text-muted">#{row.id}</div>
                        <div className="divider my-2" />
                        <div className="d-flex justify-content-between">
                            <div style={{ width: '80%' }}>
                                <div className={`text-uppercase ${orderStatus[row.status].c}`}><b>{orderStatus[row.status].t}</b></div>
                            </div>
                            <div className="text-right text-muted small">{func.numberFormat(row.items.length)} item{row.items.length > 1 ? 's' : ''}</div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div style={{ width: '80%' }} className="text-truncate">
                                <b className="text-capitalize">{row.user.name}</b>
                            </div>
                            <div className="text-right text-muted small">
                                {func.distanceMatrix(row.store.address, row.address)}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div style={{ width: '80%' }}>Distance to Restaurant</div>
                            <div className="text-right text-muted small">
                                {func.distanceMatrix(location, row.address)}
                            </div>
                        </div>
                        <div className="divider my-2" />
                        {row.paymentType === types.OrderPaymentTypes.ADVANCE && (<div className="mb-2 text-center fw-600s primary">Customer has already paid</div>)}
                        {row.paymentType === types.OrderPaymentTypes.DELIVERY && (<div className="mb-2 text-center fw-600 primary" style={{ fontSize: 18 }}>₦{func.numberFormat(row.amount.total)}</div>)}

                        <div className="muted small mb-3">
                            <img src={images.Location} alt="Location" height={15} /> {row.address.name}
                        </div>

                        {row.items.map((item, i) => {
                            let options: string[] = [];
                            Object.keys(item.variants).forEach((po) => {
                                for (let variant of item.variants[po]) {
                                    options.push(`x${variant.quantity} ${variant.name}${+variant.price ? ` (+${func.numberFormat(variant.price, 2)})` : ''}`);
                                }
                            });
                            return (
                                <div key={`${i}_${item.uuid}`} className="d-flex border- p-2s rounded mb-2">
                                    {/* <div style={{ width: '4.5vh' }}>
                                            <div className="bg-img border" style={{ backgroundImage: `url("${(item.imagesLinks || [])[0] || images.Logo}")`, height: '4.5vh', borderRadius: 4 }} />
                                        </div> */}
                                    <div className="ml-2s">
                                        <span className="fw-600">x{item.quantity}</span> {item.name}
                                        {options.map(option => <div key={option} className="small text-muted pl-2">{option}</div>)}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Touchable>
        </React.Fragment>
    );
}

export default OrderCard;